/**
 * Debug logger — silent in production unless enabled.
 *
 * Enable in browser:
 *   localStorage.setItem("debug", "true")   then refresh
 *   — or —
 *   add ?debug=true to the URL
 *
 * Disable:
 *   localStorage.removeItem("debug")        then refresh
 */

const isEnabled = () => {
  if (process.env.NODE_ENV !== "production") return true;

  try {
    if (window.localStorage.getItem("debug") === "true") return true;
    if (new URLSearchParams(window.location.search).has("debug")) {
      window.localStorage.setItem("debug", "true");
      return true;
    }
  } catch (_) {
    // private browsing or localStorage blocked
  }

  return false;
};

const DEBUG = isEnabled();

const logger = {
  log: DEBUG ? console.log.bind(console) : () => {},
  warn: DEBUG ? console.warn.bind(console) : () => {},
  error: DEBUG ? console.error.bind(console) : () => {},
  info: DEBUG ? console.info.bind(console) : () => {},
};

export default logger;
